import * as _ from 'lodash'
import * as React from 'react'
import { HttpRequest } from 'util/http';
import { userData } from 'util/userData';
import { Button } from '../../components/ui/Button';
import { ButtonGroup } from '../../components/ui/ButtonGroup';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import { Modal, ModalContent, ModalFooter } from '../../components/ui/Modal';
import { Popover } from '../../components/ui/Popover';
import { Tooltip } from '../../components/ui/Tooltip';
import { ActionAlertFormContainer } from '../ActionAlertFormContainer';
import { getActionStatusIcon } from '../CoachingFormContainer/util';
import { DelayedTooltip } from "../../components/ui/DelayedTooltip";
import WowItemModalComponent from "./WowItemModalComponent";
import ToggleFlagConfirmationModalComponent from "./ToggleFlagConfirmationModalComponent";
import { NestedAvidSelect } from "../../components/ui/NestedAvidSelect";
import { NestedAvidCheckbox } from "../../components/ui/NestedAvidCheckbox";
import { ModalHeader } from "reactstrap";

interface ICoachingFormHeaderProps {
  isWow?: boolean
  isPs?: boolean
  actionItemStatus?: string
  isResolved?: boolean
  statusColor?: string
  isSalesOpportunity?: boolean
  isAttritionRisk?: boolean
  currentActionAlert?: IActionAlert
  associatedAvid?: string
  associatedAvidLabel?: string
  enableSurveyAttributesUpdate?: boolean
}

interface IActionAlertReason {
  id: number
  reason: string
}

interface IActionAlert {
  id?: number
  client?: string
  externalDataReference?: string
  survey?: string
  username?: string
  reasonId?: number
  reasonText?: string
  description?: string
  isDeleted?: number
  isDeletable?: boolean
  isEditable?: boolean
  isActionItem?: boolean
  currentStatusId?: number
  currentStatus?: string
  jhIntegrationStatus?: string
  jhEventId?: string
  jhSyncedAt?: string
  jhErrorMessage?: string
}

interface ICoachingFormHeaderState {
  reasons: IActionAlertReason[]
  openModal: boolean
  openDeleteModal: boolean
  openActionAlertForm: boolean
  currentActionAlert: IActionAlert | undefined
  attachedActionAlerts: IActionAlert[]
  currentStatus?: string
  newAlert: {
    reasonId: number
    description: string
  }
  selectedActionAlertID?: number
  enableActionAlerts: boolean
  enableClassicActionAlerts: boolean
  actionAlertsViewSetupLoaded: string[]
  wowItemModalOpen: boolean
  salesOpportunityModalOpen: boolean
  hierarchySelectionModalOpen: boolean
  hierarchySelectionModalSubmitting: boolean
  childConfirmationModalOpen: boolean
  confirmedChangeHierarchyModalOpen: boolean
  confirmedChangeHierarchyModalSubmitting: boolean
  organizationalAssignmentModalOpen: boolean
  isWow: boolean
  isSalesOpportunity: boolean
  selectedAvid?: string
  selectedAvidLabel?: string
  dynamicChildren?: IDynamicChildren
  shouldFetchNestedSurvey: boolean; // <-- Added this property
}

interface IDynamicChildren {
  id: string;
  label: string;
}

interface IDynamicChildrenResponseData {
  hasDynamicChildren: boolean;
  dynamicChildren: IDynamicChildren;
}

interface IDynamicChildrenBackendResponse {
  data: IDynamicChildrenResponseData;
}

export class CoachingFormHeader extends React.Component<ICoachingFormHeaderProps, ICoachingFormHeaderState> {

  static getDerivedStateFromProps(nextProps, prevState) {
    let status = prevState.currentStatus
    let currentActionAlert = prevState.currentActionAlert
    if (nextProps.actionItemStatus !== status) {
      status = nextProps.actionItemStatus
    }
    if (nextProps.currentActionAlert.externalDataReference !== currentActionAlert.externalDataReference) {
      currentActionAlert = nextProps.currentActionAlert
    }
    return {
      reasons: prevState.reasons,
      openModal: prevState.openModal,
      openDeleteModal: prevState.openDeleteModal,
      style: prevState.style,
      status: status,
      // isWow: nextProps.isWow,
    }
  }

  state: ICoachingFormHeaderState = {
    reasons: [],
    openModal: false,
    openDeleteModal: false,
    openActionAlertForm: false,
    currentActionAlert: {},
    attachedActionAlerts: [],
    currentStatus: '',
    newAlert: {
      reasonId: 1,
      description: ''
    },
    enableActionAlerts: false,
    enableClassicActionAlerts: false,
    actionAlertsViewSetupLoaded: [],
    wowItemModalOpen: false,
    salesOpportunityModalOpen: false,
    hierarchySelectionModalOpen: false,
    hierarchySelectionModalSubmitting: false,
    confirmedChangeHierarchyModalOpen: false,
    confirmedChangeHierarchyModalSubmitting: false,
    organizationalAssignmentModalOpen: false,
    childConfirmationModalOpen: false,
    isWow: false,
    isSalesOpportunity: false,
    shouldFetchNestedSurvey: false, // <-- Initialize here
  };

  constructor(props) {
    super(props)
    this.loadActionAlertReason()
    this.setAdvancedActionAlerts();
    this.setClassicActionAlerts();
    this.state.currentStatus = this.props.actionItemStatus
    this.state.isWow = this.props.isWow
    this.state.isSalesOpportunity = this.props.isSalesOpportunity
    this.state.selectedAvid = this.props.associatedAvid ? this.props.associatedAvid : undefined
  }

  resolveCoachingFormHeaderLoaded = null

  componentDidMount() {
    //Promise to make sure all Alerts are set for the Header
    //Plus resets Promise on every did mount
    const headerIsLoaded = new Promise((resolve) => {
      this.resolveCoachingFormHeaderLoaded = resolve
    })
    // @ts-ignore
    window.coachingformHeaderLoaded = headerIsLoaded;
    ////

    window.addEventListener('updateRecords', () => {
      this.setState({ openActionAlertForm: false }, () => {
        this
          .loadAttachedActionAlerts(parseInt(this.props.currentActionAlert.externalDataReference), this.props.currentActionAlert.survey)
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { openActionAlertForm } = this.state;
    if (openActionAlertForm != prevState.openActionAlertForm && !openActionAlertForm)
      this.setState({ selectedActionAlertID: undefined });
    if (prevProps.actionItemStatus != this.props.actionItemStatus)
      this.setState({ currentStatus: this.props.actionItemStatus })
    if (prevState.currentActionAlert !== this.state.currentActionAlert)
      this.loadAttachedActionAlerts(parseInt(this.props.currentActionAlert.externalDataReference), this.props.currentActionAlert.survey)
    if (prevState.attachedActionAlerts !== this.state.attachedActionAlerts) {
      // Determine if attached action alerts will affect the attrition risk and sales opportunity flags
      let reasonsForActionAlerts = [];
      if (this.state.attachedActionAlerts.length > 0) {
        reasonsForActionAlerts = this.state.attachedActionAlerts.reduce((acc, curr) => {
          return acc.concat(curr.reasonText)
        }, [])
      }
      if (reasonsForActionAlerts.includes("Sales Opportunity")) {
        this.setState({ isSalesOpportunity: true })
      }
    }
  }


  loadActionAlertReason() {
    const params = {}
    HttpRequest.fetch<IActionAlertReason[]>('scripts/coaching_form/getActionAlertReasons', { params })
      .then((reasons) => {
        this.state.reasons = reasons
      });
  }

  setAdvancedActionAlerts() {
    const method = 'POST';
    HttpRequest.fetch<any>
      ('scripts/coaching_form/enableActionAlerts', { method })
      .then((enableActionAlerts) => {
        let actionAlertsView = Object.assign(this.state.actionAlertsViewSetupLoaded)
        actionAlertsView.push('advancedActionAlerts')
        actionAlertsView.push('loadingAttachedActionAlerts')

        this.setState({ actionAlertsViewSetupLoaded: actionAlertsView })
        this.setState({ enableActionAlerts: enableActionAlerts }, () => {
          this.loadAttachedActionAlerts(parseInt(this.props.currentActionAlert.externalDataReference), this.props.currentActionAlert.survey);
        });
      });
  }

  setClassicActionAlerts() {
    const method = 'POST';
    HttpRequest.fetch<any>
      ('scripts/coaching_form/enableClassicActionAlerts', { method })
      .then((enableClassicActionAlerts) => {
        let actionAlertsView = Object.assign(this.state.actionAlertsViewSetupLoaded)
        actionAlertsView.push('classicActionAlerts')
        this.setState({ actionAlertsViewSetupLoaded: actionAlertsView })
        this.setState({ enableClassicActionAlerts: enableClassicActionAlerts });
      });
  }

  loadAttachedActionAlerts(coachingFormID: number, survey: string) {
    const data = { coachingFormID: coachingFormID, survey: survey };
    const method = 'POST';
    HttpRequest.fetch<IActionAlert[]>
      ('/scripts/action_alerts/action_alert/getAttachedActionAlerts', { data, method })
      .then((actionAlerts) => {
        try {
          if (actionAlerts.length > 0) {
            this.setState({ attachedActionAlerts: actionAlerts, currentStatus: (actionAlerts[0].currentStatus ? actionAlerts[0].currentStatus : 'New') });
            let updatedCurrentActionAlert = this.props.currentActionAlert
            if (actionAlerts[0].reasonText.length && actionAlerts[0].reasonText !== ' ') updatedCurrentActionAlert.reasonText = actionAlerts[0].reasonText
            if (actionAlerts[0].description.length && actionAlerts[0].description !== ' ') updatedCurrentActionAlert.description = actionAlerts[0].description
            updatedCurrentActionAlert.isActionItem = true
            updatedCurrentActionAlert.reasonId = actionAlerts[0].reasonId ? actionAlerts[0].reasonId : 1
            updatedCurrentActionAlert.id = actionAlerts[0].id

            this.setState({
              currentActionAlert: updatedCurrentActionAlert,
            })
          } else {
            let updatedCurrentActionAlert = Object.assign(this.state.currentActionAlert)
            updatedCurrentActionAlert.isActionItem = false
            this.setState({ currentActionAlert: updatedCurrentActionAlert, attachedActionAlerts: [] })
          }

          if (actionAlerts.length > 0) {
            const updateList = new CustomEvent('updateCoachingOverview', {
              detail: {
                isActionItem: true,
                externalDataReference: coachingFormID
              }
            });
            window.dispatchEvent(updateList)
            //Promise to make sure all Alerts are set
            this.resolveCoachingFormHeaderLoaded()

          } else {
            // If Advanced AA is enabled and there are no attached AA, unmark currentActionAlert as
            //  isActionItem: false
            let updatedcurrentActionAlert = Object.assign(this.state.currentActionAlert)
            updatedcurrentActionAlert.isActionItem = false
            this.setState({ currentActionAlert: updatedcurrentActionAlert })
            const updateList = new CustomEvent('updateCoachingOverview', {
              detail: {

                isActionItem: false,
                externalDataReference: coachingFormID
              }
            });
            window.dispatchEvent(updateList)
            //Promise to make sure all Alerts are set
            this.resolveCoachingFormHeaderLoaded()

          }
          let actionAlertsView = Object.assign(this.state.actionAlertsViewSetupLoaded)
          actionAlertsView = actionAlertsView.filter(item => item !== 'loadingAttachedActionAlerts')
          this.setState({ actionAlertsViewSetupLoaded: actionAlertsView })
        }
        catch (e) {
          console.error(e.message);
        }
      })
      .catch((reason => console.error('Could not get attached Action Alerts')));
  }

  updateModalState(openModal) {
    const { newAlert, currentActionAlert } = this.state


    this.updateHeaderPosition(openModal);

    newAlert.reasonId = (typeof currentActionAlert.reasonId === 'undefined' || currentActionAlert.reasonId < 1) ? 1 : currentActionAlert.reasonId
    newAlert.description = currentActionAlert.description ? currentActionAlert.description : ''

    this.setState({ openModal, newAlert, currentActionAlert })
  }
  updateHeaderPosition(isStatic: boolean) {
    /**
     * As #coachingHeader element is not a React component (just HTML)
     * I just got the element using pure JS and toggle position attribute to work
     * properly when the .modal-overlay was displayed
     */
    let componentParentHeader = document.getElementById('coachingHeader')
    if (isStatic) {
      componentParentHeader.setAttribute('style', 'position: static')
    } else {
      componentParentHeader.removeAttribute('style')
    }
  }

  updateDeleteModalState(openDeleteModal) {
    const coachingHeaderElement = document.getElementById('coachingHeader')
    const popOverContentElement = coachingHeaderElement.getElementsByClassName('btn-popover-content')[0]
    if (openDeleteModal) {
      coachingHeaderElement.style.position = 'relative'
      popOverContentElement.setAttribute('style', 'display: none')
    } else {
      coachingHeaderElement.removeAttribute('style')
      popOverContentElement.removeAttribute('style')
    }
    this.setState({ openDeleteModal })
  }

  updateNewStatus(attr, value) {
    const { newAlert } = this.state
    newAlert[attr] = value

    this.setState({ newAlert })
  }

  saveActionAlert(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    const { id } = this.state.currentActionAlert
    const { reasonId, description } = this.state.newAlert
    const { survey, externalDataReference } = this.props.currentActionAlert
    userData.getUserId().then((userId) => {
      const params = { survey, id, externalDataReference, description, reasonId, originalReason: this.state.currentActionAlert.reasonText, originalDescription: this.state.currentActionAlert.description, associatedAvid: this.props.associatedAvid, userId }
      const body = JSON.stringify({ survey, id, externalDataReference, description, reasonId, originalReason: this.state.currentActionAlert.reasonText, originalDescription: this.state.currentActionAlert.description })
      const method = 'POST'
      const endpoint = id > 0 ? 'scripts/action_alerts/action_alert/updateActionItem' : 'scripts/action_alerts/action_alert/markAsActionItem'
      HttpRequest.fetch<IActionAlert>(endpoint, { params, method, body })
        .then((currentActionAlert) => {
          this.updateModalState(false)
          this.setState({ currentActionAlert, currentStatus: currentActionAlert.currentStatus })
          const updateList = new CustomEvent('updateCoachingOverview', { detail: currentActionAlert });
          window.dispatchEvent(updateList)
          const event = new CustomEvent('refreshStatusSection')
          window.dispatchEvent(event)
          if (window.opener) {
            window.opener.postMessage('refreshStatuses', location.origin)
          }
        })
    })
  }

  deleteActionAlert() {
    const { currentActionAlert } = this.state
    currentActionAlert.isDeleted = 1
    const params = currentActionAlert
    const body = JSON.stringify(currentActionAlert)
    const method = 'POST'
    HttpRequest.fetch<IActionAlert>('scripts/action_alerts/action_alert/deleteActionItem', { params, method })
      .then((caa) => {
        this.updateDeleteModalState(false)
        this.setState({ currentActionAlert: caa, currentStatus: caa.currentStatus, })
        const updateList = new CustomEvent('updateCoachingOverview', { detail: caa })
        window.dispatchEvent(updateList)
        const event = new CustomEvent('refreshStatusSection')
        window.dispatchEvent(event)
        if (window.opener) {
          window.opener.postMessage('refreshStatuses', location.origin)
        }
      })
  }

  scrollToAlertStatus(): any {
    const coachingStatus = document.getElementById('coachingStatus')
    $('html, body').animate({
      scrollTop: $(coachingStatus).offset().top - 20
    }, 500)
  }

  getJackHenrySyncStatusIcon(alert: IActionAlert) {
    const { jhIntegrationStatus, jhEventId, jhSyncedAt, jhErrorMessage } = alert;

    if (!jhIntegrationStatus) {
      return null; // No integration attempted
    }

    if (jhIntegrationStatus === 'synced' && jhEventId) {
      const tooltipText = `Synced to Synapsis\nEvent ID: ${jhEventId}\n${jhSyncedAt ? new Date(jhSyncedAt).toLocaleString() : ''}`;
      return (
        <Tooltip text={tooltipText} position="bottom">
          <FontAwesomeIcon icon="check-circle" color="green" fixedWidth />
        </Tooltip>
      );
    }

    if (jhIntegrationStatus === 'failed') {
      const tooltipText = `Sync to Synapsis failed\n${jhErrorMessage || 'Unknown error'}`;
      return (
        <Tooltip text={tooltipText} position="bottom">
          <FontAwesomeIcon icon="exclamation-circle" color="red" fixedWidth />
        </Tooltip>
      );
    }

    // Pending or unknown status
    return (
      <Tooltip text="Sync pending" position="bottom">
        <FontAwesomeIcon icon="clock" color="gray" fixedWidth />
      </Tooltip>
    );
  }

  openAddStatusModal(): any {
    const event = new CustomEvent('openAddStatus')
    window.dispatchEvent(event)
  }

  toggleActionAlertFormModal() {
    const { openActionAlertForm } = this.state;
    this.setState({ openActionAlertForm: !openActionAlertForm });
  }

  toggleWowItemModal() {
    const { wowItemModalOpen } = this.state;
    this.updateHeaderPosition(!wowItemModalOpen);
    this.setState({ wowItemModalOpen: !wowItemModalOpen });
  }
  toggleIsSalesOpportunityModal() {
    const { salesOpportunityModalOpen } = this.state;
    this.updateHeaderPosition(!salesOpportunityModalOpen);
    this.setState({ salesOpportunityModalOpen: !salesOpportunityModalOpen });
  }

  toggleChangeHierarchyModal() {
    const { hierarchySelectionModalOpen } = this.state;

    if (!hierarchySelectionModalOpen) {
      this.setState({ shouldFetchNestedSurvey: true }); // Enable fetching
    } else {
      this.setState({ shouldFetchNestedSurvey: false }); // Disable fetching
    }

    this.updateHeaderPosition(!hierarchySelectionModalOpen);
    this.setState({ hierarchySelectionModalOpen: !hierarchySelectionModalOpen });
  }

  toggleWowItemStatus() {
    const { isWow } = this.state;
    this.setState({ isWow: !isWow });
  }

  toggleSalesOpportunityStatus() {
    const { isSalesOpportunity } = this.state;
    this.setState({ isSalesOpportunity: !isSalesOpportunity }, () => {
      this.loadAttachedActionAlerts(parseInt(this.props.currentActionAlert.externalDataReference), this.props.currentActionAlert.survey);
    });
  }

  toggleConfirmationChangeHierarchyModal() {
    const { confirmedChangeHierarchyModalOpen } = this.state;
    this.setState({ confirmedChangeHierarchyModalOpen: !confirmedChangeHierarchyModalOpen });
  }

  render() {
    const { isPs, isResolved, actionItemStatus, statusColor, enableSurveyAttributesUpdate } = this.props;
    const { isWow } = this.state;
    let isAttritionRisk = this.props.isAttritionRisk
    const { currentStatus, attachedActionAlerts, selectedActionAlertID, enableActionAlerts, enableClassicActionAlerts, actionAlertsViewSetupLoaded } = this.state
    const { id, reasonText, description, isDeletable, isEditable } = this.state.currentActionAlert
    const isActionItem = this.state.currentActionAlert.isActionItem || attachedActionAlerts.length > 0
    const cursor = 'pointer'
    const display = actionItemStatus ? 'visible' : 'none'
    const resolutionBtnStyle = { cursor, display }
    const { salesOpportunityModalOpen } = this.state
    const { isSalesOpportunity } = this.state
    //let renderIsSalesOpportunity = JSON.parse(JSON.stringify(this.state.isSalesOpportunity));
    const { currentActionAlert } = this.state;
    const { hierarchySelectionModalOpen, hierarchySelectionModalSubmitting, confirmedChangeHierarchyModalOpen, confirmedChangeHierarchyModalSubmitting, childConfirmationModalOpen, dynamicChildren } = this.state;



    const url = new URL(window.location.href);
    const externalDataReference = url.searchParams.get('id');
    const surveyAbbreviation = url.searchParams.get('survey');

    let reasonsForActionAlerts = []

    // attached action alerts override isAttritionRisk and isSalesOpportunity props
    if (attachedActionAlerts.length > 0) {
      reasonsForActionAlerts = attachedActionAlerts.reduce((acc, curr) => {
        return acc.concat(curr.reasonText)
      }, [])

      //renderIsSalesOpportunity = reasonsForActionAlerts.includes("Sales Opportunity") || renderIsSalesOpportunity
      isAttritionRisk = reasonsForActionAlerts.includes("Attrition Risk") || isAttritionRisk
    }
    let currentActionItemStatusText = ''

    if (currentStatus) {
      currentActionItemStatusText = currentStatus
    } else {
      if (isActionItem) {
        currentActionItemStatusText = 'New'
      } else {
        currentActionItemStatusText = 'N/A'
      }
    }

    let openActionAlertForm = this.state.openActionAlertForm;
    let currentActionAlertExternalDataReference = this.props.currentActionAlert.externalDataReference;
    let associatedAvid = this.props.associatedAvid;
    let childrenInfoStyle = {
      padding: '0.5rem 1rem',
      fontSize: '1.25rem',
      lineHeight: '1.5',
      borderRadius: '0.3rem',
      borderColor: 'black',
      borderStyle: 'solid',
      borderWidth: '1px',
    };
    return (
      <>
        <section className="blacklight">
          <header>
            <section className="coaching-form-header-container">
              <header className="coaching-form-header row">
                <section className="col-sm-4">
                  {((isActionItem && !enableActionAlerts) &&
                  actionAlertsViewSetupLoaded.length >= 2 &&
                  !actionAlertsViewSetupLoaded.includes('loadingAttachedActionAlerts')) && (() => {
                    const reason = id > 0 ? reasonText : currentActionAlert.reasonText;
                    const desc = id > 0 ? description : currentActionAlert.description;

                    // Normalize strings by removing punctuation, trimming, and lowercasing
                    const normalizeText = (text: string | undefined) => {
                      if (!text) return '';
                      return text.trim().toLowerCase().replace(/[.,!?;:]$/g, '');
                    };

                    const normalizedReason = normalizeText(reason);
                    const normalizedDesc = normalizeText(desc);
                    const same = !desc ||
                                 desc.trim() === '' ||
                                 normalizedReason === normalizedDesc;

                    return (
                      <h5 className="text-warning">
                        <b>Reason for Action Alert:&nbsp;</b>
                        <span>{reason}</span>
                        {!same && desc && desc.trim() !== '' && (
                          <>
                            <br />
                            <span>{desc}</span>
                          </>
                        )}
                      </h5>
                    );
                  })()}

                </section>
                <section className="col-sm-8">
                  <article className="d-flex justify-content-end">
                    {(enableActionAlerts && actionAlertsViewSetupLoaded.length >= 2) &&
                      <>
                        <Button className="mr-2" color="primary" onClick={() => this.toggleActionAlertFormModal()}>
                          Create New Alert
                        </Button>
                        <ActionAlertFormContainer
                          customer={{ name: 'John Doe', email: '', phoneNumber: '888-888-888' }}
                          isOpen={openActionAlertForm}
                          externalReferenceID={parseInt(currentActionAlertExternalDataReference)}
                          toggleModal={() => this.toggleActionAlertFormModal()}
                          alertID={selectedActionAlertID}
                          relatedAvid={(associatedAvid ? associatedAvid : undefined)}
                        />
                      </>
                    }

                    {enableSurveyAttributesUpdate &&
                      <a className="btn btn-link" style={{ cursor: 'pointer' }}>
                        <Tooltip text="CHANGE ORGANIZATIONAL UNIT">
                          <FontAwesomeIcon icon="address-card" color="blue"
                            onClick={() => this.toggleChangeHierarchyModal()}
                          />
                        </Tooltip>
                      </a>
                    }

                    {(enableClassicActionAlerts && actionAlertsViewSetupLoaded.length >= 2) ?
                      (<Popover className="ml-3" centerAlign={true} iconTooltip={(isActionItem ? 'Action Item' : 'Not an Action Item')} useIcon={true} icon="exclamation-triangle" isActionItem={isActionItem}>
                        <ButtonGroup>
                          <Button onClick={() => this.updateModalState(true)} disabled={(isActionItem)}>
                            <FontAwesomeIcon icon="plus" color="orange" fixedWidth />
                            <span>&nbsp;Mark as action alert</span>
                          </Button>
                          <Button onClick={() => this.updateModalState(true)} disabled={!(isActionItem && isEditable)}>
                            <FontAwesomeIcon icon="pencil-alt" color="orange" fixedWidth />
                            <span>&nbsp;Edit action alert</span>
                          </Button>
                          <Button onClick={() => this.updateDeleteModalState(true)} disabled={!(isActionItem && isDeletable)}>
                            <FontAwesomeIcon icon="trash-alt" color="orange" fixedWidth />
                            <span>&nbsp;Unmark as action alert</span>
                          </Button>
                        </ButtonGroup>
                      </Popover>)
                      :
                      (
                        !actionAlertsViewSetupLoaded.includes('loadingAttachedActionAlerts') && actionAlertsViewSetupLoaded.length >= 2 ?
                          (<a className="btn btn-link" style={{ cursor: 'default' }}>
                            <Tooltip text={(isActionItem ? 'Action Item' : 'Not an Action Item')}>
                              <FontAwesomeIcon icon="exclamation-triangle" color="orange" muted={!isActionItem} />
                            </Tooltip>
                          </a>)
                          : null
                      )
                    }
                    {enableSurveyAttributesUpdate &&
                      <a className="btn btn-link" style={{ cursor: 'pointer' }}>
                        <DelayedTooltip delay={1000}
                          text={isSalesOpportunity ? 'Click to remove the Sales Opportunity flag from this survey' : 'Click to flag as Sales Opportunity'}
                          position={"bottom"}>
                          <Tooltip text={isSalesOpportunity ? 'Sales Opportunity' : 'Not a Sales Opportunity'}>
                            <FontAwesomeIcon icon="dollar-sign" color="green" muted={!isSalesOpportunity}
                              onClick={() => this.toggleIsSalesOpportunityModal()}
                            />
                          </Tooltip>
                        </DelayedTooltip>
                      </a>
                    }
                    {!enableSurveyAttributesUpdate &&
                      <a className="btn btn-link" style={{ cursor: 'default' }}>
                        <Tooltip text={isSalesOpportunity ? 'Sales Opportunity' : 'Not a Sales Opportunity'}>
                          <FontAwesomeIcon icon="dollar-sign" color="green" muted={!isSalesOpportunity} />
                        </Tooltip>
                      </a>
                    }
                    <a className="btn btn-link" style={{ cursor: 'default' }}>
                      <Tooltip text={isAttritionRisk ? 'Attrition Risk' : 'Not an Attrition Risk'}>
                        <FontAwesomeIcon icon="asterisk" color="red" muted={!isAttritionRisk} />
                      </Tooltip>
                    </a>
                    {enableSurveyAttributesUpdate &&
                      <a className="btn btn-link" style={{ cursor: 'pointer' }}>
                        <DelayedTooltip delay={1000}
                          text={isWow ? 'Click to remove the Wow Item flag from this survey' : 'Click to flag as Wow Item'}
                          position={"bottom"}>
                          <Tooltip text={isWow ? 'WOW' : 'No WOW'}>
                            <FontAwesomeIcon icon="star" color="yellow" muted={!isWow}
                              onClick={() => this.toggleWowItemModal()} />
                          </Tooltip>
                        </DelayedTooltip>
                      </a>
                    }
                    {!enableSurveyAttributesUpdate &&
                      <a className="btn btn-link" style={{ cursor: 'default' }}>
                        <Tooltip text={isWow ? 'WOW' : 'No WOW'}>
                          <FontAwesomeIcon icon="star" color="yellow" muted={!isWow} />
                        </Tooltip>
                      </a>
                    }
                    <a className="btn btn-link" style={{ cursor: 'default' }}>
                      <Tooltip text={isPs ? 'Perfect Score' : 'Not Perfect Score'}>
                        <FontAwesomeIcon icon="check" color="green" muted={!isPs} />
                      </Tooltip>
                    </a>
                    {(!enableActionAlerts && actionAlertsViewSetupLoaded.length >= 2 && !actionAlertsViewSetupLoaded.includes('loadingAttachedActionAlerts')) &&
                      <a className="btn btn-link-hc" onClick={() => this.openAddStatusModal()}>
                        {getActionStatusIcon(currentActionItemStatusText)} {currentActionItemStatusText}
                      </a>
                    }
                  </article>
                </section>
              </header>
            </section>
          </header>
          {((enableActionAlerts && attachedActionAlerts.length > 0) && actionAlertsViewSetupLoaded.length >= 2) &&
            attachedActionAlerts.map((alert, idx) => {
              return (
                <div className="d-flex alert-banner" key={idx}>
                  <FontAwesomeIcon icon="exclamation-triangle" color="gold" style={{ flexBasis: '8%', textAlign: 'left' }} />
                  <span style={{ flexBasis: '18%' }}>{getActionStatusIcon(alert.currentStatus)}  {alert.currentStatus}</span>
                  <span className='reason' style={{ flexBasis: '26%' }}>
                    <a className="btn btn-link" style={{ cursor: 'default' }}>
                      <Tooltip text={(alert.description.length > 0 ? alert.description : 'No description available')} position='bottom'>
                        {alert.reasonText}
                      </Tooltip>
                    </a>
                  </span>
                  <span style={{ flexBasis: '22%', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {this.getJackHenrySyncStatusIcon(alert)}
                    {/*<a href={`${window.location.origin}/my_alerts?alert_id=${alert.id}`} className="link"><FontAwesomeIcon icon="search" color="primary"/>{alert.id}</a>*/}
                    <Button color="link" style={{ cursor: "pointer" }} onClick={() => {
                      this.setState({ selectedActionAlertID: alert.id }, () => {
                        this.setState({ openActionAlertForm: true });
                      })
                    }}><FontAwesomeIcon icon="search" color="primary" />{alert.id}</Button>
                  </span>
                  <span style={{ flexBasis: '26%' }}>{alert.username}</span>
                </div>
              );
            })
          }
        </section>
        <Modal open={this.state.openDeleteModal}>
          <ModalContent>
            <header>
              <h4>Unmark as an Action Alert</h4>
            </header>

            <section>
              Are you sure you want to unmark this action alert?
            </section>
          </ModalContent>
          <ModalFooter>
            <Button type="button" color="danger" onClick={() => this.deleteActionAlert()}>
              <span>UNMARK</span>
            </Button>
            <Button type="button" color="white" onClick={() => this.updateDeleteModalState(false)}>
              <span>Cancel</span>
            </Button>
          </ModalFooter>
        </Modal>
        <Modal open={this.state.openModal}>
          <form onSubmit={(e) => this.saveActionAlert(e)}>
            <ModalContent>
              <header>
                <h4>{isActionItem ? 'Edit' : 'Mark as'} Action Alert</h4>
              </header>

              <section>
                <div className="input-field">
                  <div className="label">Reason</div>
                  <select className="browser-default" required
                    value={this.state.newAlert.reasonId}
                    onChange={(e) => this.updateNewStatus('reasonId', e.target.value)}>
                    {this.state.reasons.map((reason) =>
                      <option key={reason.id} value={reason.id}>{reason.reason}</option>
                    )}
                  </select>
                </div>
                <div className="input-field">
                  <textarea className="materialize-textarea" maxLength={120} required
                    value={this.state.newAlert.description}
                    onChange={(e) => this.updateNewStatus('description', e.target.value)} />
                  <label>Description</label>
                </div>
              </section>
            </ModalContent>
            <ModalFooter>
              <Button type="submit" color="danger">
                <span>Save</span>
              </Button>
              <Button type="button" color="white" onClick={() => this.updateModalState(false)}>
                <span>Cancel</span>
              </Button>
            </ModalFooter>
          </form>
        </Modal>
        <WowItemModalComponent
          open={this.state.wowItemModalOpen}
          onConfirm={() => this.toggleWowItemStatus()}
          onClose={() => this.toggleWowItemModal()}
          isWowItem={isWow}
        />
        <ToggleFlagConfirmationModalComponent
          open={salesOpportunityModalOpen}
          isFlagActive={isSalesOpportunity}
          flagString={'Sales Opportunity'}
          postData={{
            'external_reference_id': externalDataReference,
            'survey_abbreviation': surveyAbbreviation,
          }}
          externalDataReference={Number(externalDataReference)}
          endpoint={
            `/web/v1/individual-surveys/${isSalesOpportunity ? 'remove-sales-opportunity-flag' : 'add-sales-opportunity-flag'}`
          }
          removedFlagConfirmationMessage={'Sales Opportunity flag has been removed from this survey'}
          addedFlagConfirmationMessage={'This survey has been flagged as a Sales Opportunity'}
          windowOpenerEventName={'updateHasSalesOpportunity'}
          onConfirm={() => this.toggleSalesOpportunityStatus()}
          onClose={() => this.toggleIsSalesOpportunityModal()}
        />
        <Modal open={hierarchySelectionModalOpen}
          width="80%"
        >
          <ModalHeader>
            <div style={{ backgroundColor: 'var(--brand-blue)', color: "white", marginTop: "-12px", padding: "15px" }}>
              <h5>Do you want to change the organizational assignment for this survey?</h5>
            </div>
          </ModalHeader>
          <ModalContent>
            <section>
              <div>
                <p style={{ fontWeight: "bold" }}>
                  Select a new organizational assignee
                  {" (Current: " + (this.props.associatedAvidLabel ? this.props.associatedAvidLabel : '') + ")"}
                </p>
                <NestedAvidCheckbox
                  shouldFetch={this.state.shouldFetchNestedSurvey}
                  value={this.state.selectedAvid || ''}
                  onChange={(selectedAvid, selectedAvidLabel) =>
                    this.changeSelectedAvid(selectedAvid, selectedAvidLabel)
                  }
                />
              </div>
            </section>
          </ModalContent>
          <ModalFooter>
            <Button type="button" color="primary" onClick={() => this.handleAssignmentChangeConfirmation()}>
              <span>{hierarchySelectionModalSubmitting ? 'Submitting changes' : 'Change Assignment'}</span>
            </Button>
            <Button type="button" color="white" onClick={() => this.toggleChangeHierarchyModal()}>
              <span>Cancel</span>
            </Button>
          </ModalFooter>
        </Modal>
        <Modal open={childConfirmationModalOpen}>
          <ModalContent>
            <header>
              <h4>Confirm</h4>
            </header>
            <section className="blacklight">
              <p>Please confirm employee/org child information.</p>
              <div className="row">
                <div className="col-sm-2"></div>
                <div className="col-sm-4">
                  <p className="text-center" style={childrenInfoStyle}>{dynamicChildren ? dynamicChildren.id : ''}</p>
                </div>
                <div className="col-sm-4 ">
                  <p className="text-center" style={childrenInfoStyle}>{dynamicChildren ? dynamicChildren.label : ''}</p>
                </div>
              </div>
            </section>
          </ModalContent>
          <ModalFooter>
            <div>
              <Button type="button" color="danger" onClick={() => this.setState({
                confirmedChangeHierarchyModalOpen: true,
                childConfirmationModalOpen: false,
              })}>
                <span>CONFIRM</span>
              </Button>
              <Button type="button" color="white" onClick={() => this.setState({ confirmedChangeHierarchyModalOpen: false })}>
                <span>CANCEL</span>
              </Button>
            </div>
          </ModalFooter>
        </Modal>
        <Modal open={confirmedChangeHierarchyModalOpen}>
          <ModalContent>
            <header>
              <h4>Confirm</h4>
            </header>
            <section>
              <p>You are about to move this survey and its scores from {this.props.associatedAvidLabel} to {this.state.selectedAvidLabel}. Please confirm you want to make this change.</p>
            </section>
          </ModalContent>
          <ModalFooter>
            <div>
              <Button type="button" color="danger" onClick={() => this.startAvidUpdateConfirmationProcess()}>
                <span>{confirmedChangeHierarchyModalSubmitting ? 'SUBMITTING CHANGES' : 'CONFIRM'}</span>
              </Button>
              <Button type="button" color="white" onClick={() => this.setState({ confirmedChangeHierarchyModalOpen: false })}>
                <span>CANCEL</span>
              </Button>
            </div>
          </ModalFooter>
        </Modal>
        <Modal open={this.state.organizationalAssignmentModalOpen}>
          <ModalContent>
            <p>This survey has been reallocated. You may need to reload the individual surveys dashboard before changes are visible.</p>
          </ModalContent>
          <ModalFooter>
            <Button
              type="button"
              color="white"
              onClick={() => {
                this.setState({ organizationalAssignmentModalOpen: false }, () => { });
              }}
            >
              <span>OK</span>
            </Button>
          </ModalFooter>
        </Modal>

      </>
    )
  }

  handleAssignmentChangeConfirmation() {
    const { selectedAvid, selectedAvidLabel } = this.state;
    const { associatedAvid, associatedAvidLabel } = this.props;

    // Check if the hierarchy assignment is unchanged
    if (selectedAvid === associatedAvid) {
      alert("Nothing was updated. You didn't change your selection.");
      this.setState({ hierarchySelectionModalOpen: false });
      return;
    }

    const url = new URL(window.location.href);
    const externalDataReference = url.searchParams.get('id');



    this.setState({
      hierarchySelectionModalSubmitting: true,
    });

    HttpRequest.fetch(
      '/web/v1/avids/get-dynamic-children',
      {
        method: 'POST',
        data: {
          avid: selectedAvid,
          externalDataReference,
        }
      }
    )
      .then((response: IDynamicChildrenBackendResponse) => {
        this.setState({
          hierarchySelectionModalOpen: false,
          hierarchySelectionModalSubmitting: false
        }, () => {
          setTimeout(() => {
            if (response.data.hasDynamicChildren) {
              this.setState({
                childConfirmationModalOpen: true,
                dynamicChildren: response.data.dynamicChildren,
              });
            } else {
              this.setState({ confirmedChangeHierarchyModalOpen: true });
            }
          }, 500);
        });
      })
      .catch((error) => {
        console.error('Error fetching dynamic children', error);
      })
  }

  changeSelectedAvid(selectedAvid: string, selectedAvidLabel: string): void {
    this.setState({ selectedAvid, selectedAvidLabel });
  }

  startAvidUpdateConfirmationProcess() {
    const url = new URL(window.location.href);
    const externalDataReference = url.searchParams.get('id');
    const surveyAbbreviation = url.searchParams.get('survey');
    const { selectedAvid, selectedAvidLabel } = this.state;
    HttpRequest.fetch(
      '/web/v1/individual-surveys/update-organizational-assignment',
      {
        method: 'POST',
        data: {
          originalAvid: this.props.associatedAvid,
          newAvid: this.state.selectedAvid,
          externalDataReference,
          surveyAbbreviation,
        }
      }
    )
      .then(() => {
        this.setState({
          confirmedChangeHierarchyModalSubmitting: false,
          confirmedChangeHierarchyModalOpen: false,
          organizationalAssignmentModalOpen: true,
        });
        document.getElementById("entity_name").textContent = selectedAvidLabel;
      })
      .catch((error) => {
        console.error('Error updating organizational assignment', error);
        alert('Error updating organizaitonal assignment.  More information avialable in the console log.')
      })
  }
  fetchNestedBySurvey() {
    const url = new URL(window.location.href);
    const externalDataReference = url.searchParams.get('id');
    const surveyAbbreviation = url.searchParams.get('survey');

    HttpRequest.fetch('/web/v1/get-nested-by-survey', {
      method: 'POST',
      data: {
        externalDataReference,
        surveyAbbreviation,
      },
    })
      .then((response) => {
        console.log('Nested survey data:', response);
        // Handle response, e.g., update state with the nested survey data
      })
      .catch((error) => {
        console.error('Error fetching nested survey data', error);
      });
  }
}

